import i18n from '../../managers/i18n'

i18n.register(
  'en-US',
  {
    noData: 'No result'
  },
  {
    ns: 'dropdown'
  }
)
